import React from 'react';
import { Card } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { compose } from 'react-apollo';

import PathView from '../PathView';
import DocumentTitle from '../DocumentTitle';
import Content from '../Content';
import TicketDetails from './TicketDetails';
import withTicketQuery from '../HOC/withTicketQuery';

class TicketContainer extends React.Component {
  state = {};
  handleTicketUpdated = () => this.props.refetch();
  hideLoading = () => this.setState({ loading: false });
  showLoading = () => this.setState({ loading: true });

  render = () => {
    const { ticket, loading, match, history, variables } = this.props;
    return (
      <Content fullWidth loading={loading || this.state.loading}>
        <DocumentTitle title={`Ticket ${match.params.id}`} />
        <PathView
          paths={[
            { name: 'Tickets', path: '/tickets' },
            { name: variables.id }
          ]}
        />
        <Card fluid>
          <TicketDetails
            ticket={ticket || {}}
            match={match}
            history={history}
            onTicketUpdated={this.handleTicketUpdated}
            hideLoading={this.hideLoading}
            showLoading={this.showLoading}
          />
        </Card>
      </Content>
    );
  };
}

export default compose(
  withRouter,
  withTicketQuery
)(TicketContainer);



// WEBPACK FOOTER //
// ./src/component/TicketPage/index.js